import * as React from 'react';
import './SmallInfo.scss';

export interface IProps {
    body: string;
    large?: boolean;
    marginBottom?: boolean;
    alignLeft?: boolean;
}

export interface IFunctions {}

export type IAllProps = IProps & IFunctions;

export const SmallInfo: React.SFC<IAllProps> = ({
    body,
    large,
    marginBottom,
    alignLeft,
}) => (
    <div
        className={`SmallInfo-wrap ${large && 'large-info'} ${marginBottom &&
            'margin-bottom'} ${alignLeft && 'align-left'}`}
        dangerouslySetInnerHTML={{ __html: body }}
    />
);

export default SmallInfo;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/small-info/SmallInfo.tsx